import { apiSlice } from "../api/apiSlice";
import io from "socket.io-client";


export const messagesApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getMessages: builder.query({
            query: (id) =>
                `/messages?conversationId=${id}&_sort=timestamp&_order=desc&_page=1&_limit=${process.env.REACT_APP_MESSAGES_PER_PAGE}`,
            
            transformResponse(apiResponse, meta) {
                const totalCount = meta.response.headers.get("X-Total-Count");
                return {
                    data: apiResponse,
                    totalCount,
                };
            },
            async onCacheEntryAdded(
                    arg,
                    { updateCachedData, cacheDataLoaded, cacheEntryRemoved }
                ) {
                    // create socket
                    const socket = io("https://lws-server.herokuapp.com", {
                        reconnectionDelay: 1000,
                        reconnection: true,
                        reconnectionAttemps: 10,
                        transports: ["websocket"],
                        agent: false,
                        upgrade: false,
                        rejectUnauthorized: false,
                    });
    
                    try {
                        await cacheDataLoaded;
                        socket.on("message", (data) => {
                            updateCachedData((draft) => {
                                if(draft?.data[0]?.conversationId == data?.data?.conversationId) {
                                    draft.data.push({
                                        id: data?.data?.id,
                                        conversationId: data?.data?.conversationId,
                                        sender: data?.data?.sender,
                                        receiver: data?.data?.receiver,
                                        message: data?.data?.message,
                                        timestamp: data?.data?.timestamp,
                                    });
                                }
                            });
                        });
                    } catch (err) {
                        console.log("err ", err);
                    }
    
                    await cacheEntryRemoved;
                    socket.close();
            },
         }),
         getMoreMessages: builder.query({
            query: ({ id, page }) =>
            `/messages?conversationId=${id}&_sort=timestamp&_order=desc&_page=${page}&_limit=${process.env.REACT_APP_MESSAGES_PER_PAGE}`,
            async onQueryStarted({ id, page }, { queryFulfilled, dispatch }) {
                try {
                    const messages = await queryFulfilled;
                    if (messages?.data?.length > 0) {
                        // update conversation cache pessimistically start
                        dispatch(
                            apiSlice.util.updateQueryData(
                                "getMessages",
                                id.toString(),
                                (draft) => {
                                    return {
                                        data: [
                                            ...messages.data,
                                            ...draft.data   
                                        ],
                                        totalCount: Number(draft.totalCount),
                                    };
                                }
                            )
                        );
                        // update messages cache pessimistically end
                    }
                } catch (err) {
                    console.log("err " ,err);
                }
            },
        }),
        addMessage: builder.mutation({
            query: (data) => ({
                url: "/messages",
                method: "POST",
                body: data,
            }),
        }),
    }),
});

export const { useGetMessagesQuery, useAddMessageMutation } = messagesApi;
